import OverviewContainer from "containers/jarivsPrime/Overview";
import React from "react";

const Overview = () => {
  return (
    <>
      <OverviewContainer />
    </>
  );
};

export default Overview;
